import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { INPIBanner } from './components/INPIBanner';
import { ScrollToTop } from './components/ScrollToTop';
import { QuickAccessBar } from './components/QuickAccessBar';
import { Toaster } from 'sonner';

import Home from './pages/Home';
import About from './pages/About';
import Health from './pages/Health';
import Agriculture from './pages/Agriculture';
import Education from './pages/Education';
import Investors from './pages/Investors';
import Contact from './pages/Contact';
import DealRoom from './pages/DealRoom';
import BookPicsu from './pages/BookPicsu';
import ScientificCouncil from './pages/ScientificCouncil';
import InstitutionalValidations from './pages/InstitutionalValidations';
import ProofCenter from './pages/ProofCenter';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <INPIBanner />
          <QuickAccessBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/health" element={<Health />} />
            <Route path="/agriculture" element={<Agriculture />} />
            <Route path="/education" element={<Education />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/deal-room" element={<DealRoom />} />
            <Route path="/book-picsu" element={<BookPicsu />} />
            <Route path="/scientific-council" element={<ScientificCouncil />} />
            <Route path="/validations" element={<InstitutionalValidations />} />
            <Route path="/proof-center" element={<ProofCenter />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
